import { render, staticRenderFns } from "./UserFeedback.vue?vue&type=template&id=18b6673c"
import script from "./UserFeedback.vue?vue&type=script&lang=ts"
export * from "./UserFeedback.vue?vue&type=script&lang=ts"
import style0 from "./UserFeedback.vue?vue&type=style&index=0&id=18b6673c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports